import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import userReducers from './reducers/user';
import requestsReducers from './reducers/requests';
import commonReducers from './reducers/common';
import cartReducers from './reducers/cart';
import logsReducers from './reducers/logs';

const reducersData = {
  user: userReducers,
  requests: requestsReducers,
  common: commonReducers,
  cart: cartReducers,
  logs: logsReducers,
};
export const store = configureStore({
  reducer: reducersData,
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
